import gql from 'graphql-tag';
import FragmentFeature from 'graphql/fragments/feature';
import FragmentFlag from 'graphql/fragments/flag';

export default gql`
  mutation updateFeature(
    $key: String!
    $appId: String!
    $desc: String
    $environment: String!
    $enable: Boolean!
  ) {
    updateFeature(input: { key: $key, appId: $appId, desc: $desc }) {
      ...FragmentFeature
    }

    updateFlag(
      input: {
        appId: $appId
        featureKey: $key
        environment: $environment
        enable: $enable
      }
    ) {
      ...FragmentFlag
    }
  }

  ${FragmentFeature}
  ${FragmentFlag}
`;
